import React from "react";
import { Paragraph } from "@trainline/depot-web";
import { palettes, spacers } from "@trainline/depot-web/css";
import IconTick from "../../../assets/icons/IconTick";
import IconTrackPath from "../../../assets/icons/IconTrackPath";
import TrackItem from "../../TrackItem";
import * as s from "../TransitLeg.module.css";
const AmenitiesInformationList = ({ amenities }) => {
  return /* @__PURE__ */ React.createElement(TrackItem, {
    style: { paddingTop: spacers.dp_s16 }
  }, /* @__PURE__ */ React.createElement(TrackItem.Marker, null, /* @__PURE__ */ React.createElement(IconTrackPath, null)), /* @__PURE__ */ React.createElement(TrackItem.Time, null), /* @__PURE__ */ React.createElement(TrackItem.Info, null, amenities.map((amenity) => /* @__PURE__ */ React.createElement(Paragraph, {
    key: amenity,
    as: "span",
    color: "subtle"
  }, /* @__PURE__ */ React.createElement(IconTick, {
    fill: palettes.dp_app_positive_dull
  }), /* @__PURE__ */ React.createElement("span", {
    className: s.amenityLabel
  }, amenity)))));
};
var AmenitiesInformationList_default = AmenitiesInformationList;
export {
  AmenitiesInformationList_default as default
};
